export default {
  PRODUCTIVITY: 1,
  QUALITY: 2,
  PREDICTABILITY: 3,
  ADAPTABILITY: 4
};


// WEBPACK FOOTER //
// ./src/components/utils/PrimaryAimType.js